import React, { PureComponent } from 'react'
import { Grid, Paper, Table, TableCell, TableBody, TableRow, TableHead } from '@material-ui/core'
import { hasAccess } from '../../utils/api'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import MemberProfileItem from '../../components/MemberProfile/MemberProfileItem'

const MemberProfileItemEditable = EditableHOCWrapper(MemberProfileItem)

export default class MemberProfileContainer extends PureComponent {
  render() {
    const permitted = hasAccess()

    return (
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper className="paper-page">
            <div className="table-scroll">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Required</TableCell>
                    {permitted ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <MemberProfileItemEditable data={{}} />
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MemberProfile/MemberProfileContainer.js